// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useMemo} from 'react';
import cn from 'classnames';
import {img_url} from '../../../ui/img_url';
import {Settings_context} from '../../../settings_ctx';
import {Button} from '../../../lib/button';
import styles from '../../../products/products.module.less';
import {use_browser} from '../../../lib/use_browser';
import {open_store} from '../../../ui/install_btn';
import Icon_edge_active from '../../../img/svg/pl/ic-edge-active.svg';
import Icon_chrome_active from '../../../img/svg/pl/ic-chrome-active.svg';
import Icon_opera_active from '../../../img/svg/pl/ic-opera-active.svg';
import {How_it_works_2} from '../../../ui/homepage/how_it_works_2';
import {Lottie} from '../../../lib/lottie';
import {use_element_size, use_screen} from '../../../lib/screen_util';
// @ts-ignore
import {App_context} from '../../../context.js';
import {On_scroll_animation} from '../../../ui/on_scroll_animation';
import {Faq_question} from '../../../products/faq_question';
// @ts-ignore
import {open_link} from '../../../install_util.js';

export const Root = (props: any)=>{
    const {theme} = useContext(Settings_context);
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const br = use_browser(['chrome', 'opera', 'edge']);
    const title = br.toUpperCase()[0] + br.substring(1);
    const other_browsers = useMemo(()=>{
        if (br == 'chrome')
            return ['opera', 'edge'];
        if (br == 'opera')
            return ['chrome', 'edge'];
        if (br == 'edge')
            return ['chrome', 'opera'];
    }, [br]);
    const {screen} = use_screen();
    const [w, h] = use_element_size(is_client && {
        xs: [240, 200],
        md: [240, 200],
        all: [467, 387],
    });
    return <div className={theme.root}>
      <div className={styles.top}>
        <div className={styles.text}>
          <h2>Your browser is about to go Borderless</h2>
          <p className={theme.u3}>Your gateway to your favorite movies,
            TV shows, games and more, no matter where you live!</p>
          <Button color={'black2023'} caption={`Add to ${title} - it's free`}
            on_click={()=>{
              open_store(false, br);
            }} size={'lg'}/>
        </div>
        <div className={styles.man_img} key={screen}>
          <Lottie src={img_url('animation/products_extension.json')}
            width={w} height={h} autoplay
            cls={styles.man_lottie}/>
        </div>
      </div>
      <div className={styles.other_browsers_wrap}>
        <div className={styles.other_browsers}>
          <p className={cn(theme.p2, theme.med)}>Also available on</p>
          {other_browsers.map(b=>{
            return <button key={b}
              className={styles.browser_button} onClick={()=>{
                open_store(true, b);
              }}>
                {b=='opera' && <Fragment><Icon_opera_active/> <span
                  className={cn(theme.P, theme.p2, theme.med)}>Opera
                  Browser</span></Fragment>}
                {b=='edge' && <Fragment><Icon_edge_active/> <span
                  className={cn(theme.P, theme.p2, theme.med)}>Microsoft
                  edge</span></Fragment>}
                {b=='chrome' && <Fragment><Icon_chrome_active/> <span
                className={cn(theme.P, theme.p2, theme.med)}>Chrome
                  Browser</span></Fragment>}
              </button>;
          })}
        </div>
      </div>
      <How_it_works_2 is_promo_browser={false} app_fixed={'ext'}
        user_country={props.user_country} treshold_abs={300}
        title_h3 with_margin_after_icon/>
      <div className={styles.dont_take_block}>
        <img src={img_url('hola2023/stars.svg')} width={362} height={104}
          alt="stars" className="lazyload"/>
        <h3>Don't just take our word for it</h3>
        <p className={cn(theme.u3)}>Hola is trusted by more than 263 million
          people around the globe!</p>
        <div className={styles.reviews}>
          <div className={styles.one_review}>
            <div className={styles.review_platform}
              title={'hola on chrome webstore'}
              onClick={()=>open_link('chrome')}>
              <img src={img_url('hola2023/review_chrome_webstore.svg')}
                alt="chrome" className="lazyload"/>
              <p className={cn(theme.p3, theme.med)}><img alt="stars"
                className="lazyload"
                src={img_url('hola2023/review_chrome_webstore_stars.svg')}/>
                4.9 <span>|</span> 360,000+ reviews
              </p>
            </div>
            <div className={styles.review_text}>
              <p className={cn(theme.p2)}>
                "OMG, it works. I love it! I tried like 20 other
                VPN's (...) This one worked like a charm".
              </p>
              <div className={styles.name_and_pl}>
                <p className={theme.u4}>Sany Sanichar</p>
                <p className={theme.u4}>Chrome Web Store</p>
              </div>
            </div>
          </div>
          <div className={cn(styles.one_review, styles.hidden_for_middle)}>
            <div className={styles.review_platform}
              title={'hola on chrome webstore'}
              onClick={()=>open_link('chrome')}>
              <img src={img_url('hola2023/review_chrome_webstore.svg')}
                alt="chrome" className="lazyload"/>
              <p className={cn(theme.p3, theme.med)}><img alt="stars"
                className="lazyload"
                src={img_url('hola2023/review_chrome_webstore_stars.svg')}/>
                4.9 <span>|</span> 360,000+ reviews
              </p>
            </div>
            <div className={styles.review_text}>
              <p className={cn(theme.p2)}>
                "Simple to use and it worked when another VPN extension I was
                using stopped working".
              </p>
              <div className={styles.name_and_pl}>
                <p className={theme.u4}>Filip Stojanov</p>
                <p className={theme.u4}>Chrome Web Store</p>
              </div>
            </div>
          </div>
          <div className={styles.one_review}>
            <div className={styles.review_platform}
              title={'hola on opera addons'}
              onClick={()=>open_link('opera')}>
              <img src={img_url('hola2023/review_opera.svg')} alt="opera"
                className="lazyload"/>
              <p className={cn(theme.p3, theme.med)}><img alt="stars"
                className="lazyload"
                src={img_url('hola2023/review_opera_stars.svg')}/>
                4.1 <span>|</span> 2,300+ reviews
              </p>
            </div>
            <div className={styles.review_text}>
              <p className={cn(theme.p2)}>
                "Perfect VPN, it even works with Disney+ to acess
                region-only content. Thanks!".
              </p>
              <div className={styles.name_and_pl}>
                <p className={theme.u4}>santyrios514</p>
                <p className={theme.u4}>Opera addons</p>
              </div>
            </div>
          </div>
        </div>
        <Button color={'black2023'} caption={`Add to ${title} - it's free`}
          on_click={()=>{
            open_store(false, br);
          }} size={'lg'}/>
      </div>
      <div className={styles.faq}>
        <div className={styles.faq_content}>
          <div className={styles.faq_column}>
            <h3>Common questions people ask</h3>
            <Faq_question quest={'Can I use the Hola VPN extension for free?'}
              ans={<Fragment>Absolutely! At Hola, we are committed to
                democratizing access to online content. Both our free
                and <a
                  href='/premium?ref=from_faq_products'>Premium</a> versions
                are designed to provide you with access to worldwide content,
                regardless of your location. The free version allows you to
                enjoy Hola VPN without any cost but with some time limits.
                However, for those seeking additional benefits, such as
                unlimited VPN time, usage on multiple devices, HD streaming,
                enhanced performance and more, you can choose to upgrade
                to our <a
                  href='/premium?ref=from_faq_products'>Premium</a> version
                at any time.</Fragment>}/>
            <Faq_question quest={'Why do I need a VPN for my browser?'}
              ans={<Fragment>Many websites and online services restrict
                access based on your location. A VPN allows you to connect
                to peers or servers in different regions and countries and
                thereby access content from around the world.</Fragment>}/>
            <Faq_question
              quest="Does Hola VPN impact the speed of my internet connection?"
              ans={<Fragment>Hola VPN is designed to minimize speed loss.
                With our specially engineered ultra-fast servers and
                unlimited bandwidth, we strive to provide a seamless and
                high-speed VPN experience for our users.</Fragment>}/>
            <Faq_question quest={'Can I use Hola VPN on multiple devices?'}
              ans={<Fragment>Yes! You can use <a
                href='/premium?ref=from_faq_products'>Hola Premium</a> on
                phones, computers, tablets, TVs, routers, gaming consoles,
                browser extensions & more.</Fragment>}/>
          </div>
          <div className={styles.faq_smiles}>
            <On_scroll_animation key={'faq_lottie'}
              src={`animation/support_product.json`} size={[440, 320]}
              animation={[{frames: {from: 50, to: 75}, direction: 1,
                loop: false}]}
              cls={styles.faq_lottie} scroll_to_pos={0.05}/>
          </div>
        </div>
      </div>
      <div className={styles.title_plus_btn}>
        <h3>Never miss another episode, movie, game or match with the
          Hola extension!</h3>
        <Button color={'black2023'} caption={`Add to ${title} - it's free`}
          on_click={()=>{
            open_store(false, br);
          }} size={'lg'}/>
      </div>
    </div>;
};
Root.meta = {
    default_theme: 'hola2023',
    meta: {
        title: 'Your browser is about to go Borderless',
        description: 'Your gateway to your favorite movies, TV shows, games'
          +' and more, no matter where you live!',
        canonical_url: 'https://hola.org/products/extension',
    },
};
